import useAsyncData from 'src/utils/useAsyncData';
import { getAccountProfileAPI } from 'src/serverApi/account';

const useAccountProfile = () => {
  const [
    fetchAccountProfile,
    wasAccountProfileFetched,
    isAccountProfileLoading,
    accountProfile,
    accountProfileError,
  ] = useAsyncData(getAccountProfileAPI);

  return {
    fetchAccountProfile,
    wasAccountProfileFetched,
    isAccountProfileLoading,
    accountProfile,
    accountProfileError,
  };
};

export default useAccountProfile;
